import { IFloorsSelectedSection } from 'src/typings/floors';
import { IFirstSpinner } from 'src/typings/spinner';
import { IAction } from 'src/typings';
import { ActionTypes as TypeOfPropertyActionTypes } from 'src/store/requests/type-of-property/actions';
import { ActionTypes } from './actions';

export interface IFloorsStateReducer {
  selectedHouse: IFirstSpinner | null;
  selectedSection: IFloorsSelectedSection;
  selectedFloor: string | null;
  selectedFloorNumber: string | null;
  filteredIds: string[];
  filteredSections: string[];
  selectedApartmentId: string;
  fromComplex: boolean;
  originSpinner: IFirstSpinner | null;
}

export const initialState: IFloorsStateReducer = {
  selectedHouse: null,
  selectedSection: {
    markup: null,
    'markup-id': null,
  },
  selectedFloor: null,
  selectedFloorNumber: null,
  filteredIds: [],
  filteredSections: [],
  selectedApartmentId: '',
  fromComplex: false,
  originSpinner: null,
};

export const floorsReducer = (
  state = initialState,
  { type, payload }: IAction,
): IFloorsStateReducer => {
  switch (type) {
    case ActionTypes.SET_SELECTED_SECTION: {
      return {
        ...state,
        selectedSection: payload,
      };
    }

    case ActionTypes.SET_SELECTED_HOUSE: {
      return {
        ...state,
        selectedHouse: payload,
      };
    }

    case ActionTypes.SET_SELECTED_FLOOR: {
      return {
        ...state,
        selectedFloor: payload,
      };
    }

    case ActionTypes.SET_SELECTED_FLOOR_NUMBER: {
      return {
        ...state,
        selectedFloorNumber: payload,
        selectedApartmentId: '',
      };
    }

    case ActionTypes.SET_FLOOR_REDUCER: {
      return {
        ...state,
        ...payload,
      };
    }

    case ActionTypes.SET_FILTERED_FLOORS_IDS: {
      return {
        ...state,
        filteredIds: payload,
      };
    }
    case ActionTypes.SET_FILTERED_SECTIONS: {
      return {
        ...state,
        filteredSections: payload,
      };
    }

    case ActionTypes.SET_SELECTED_APARTMENT_ID: {
      return {
        ...state,
        selectedApartmentId: payload,
      };
    }
    case ActionTypes.SET_FROM_COMPLEX: {
      return {
        ...state,
        fromComplex: payload,
      };
    }
    case ActionTypes.SET_ORIGIN_SPINNER: {
      return {
        ...state,
        originSpinner: payload,
      };
    }

    case ActionTypes.SET_INITIAL_REDUCER: {
      return {
        ...initialState,
      };
    }

    case ActionTypes.RESET_NAVIGATION_REDUCER: {
      return {
        ...initialState,
        filteredIds: state.filteredIds,
        filteredSections: state.filteredSections,
      };
    }

    // Change the placement type and invalidate its dependent floor navigation
    // atomically. This prevents rendering a new catalogue with an old section.
    case TypeOfPropertyActionTypes.CHANGE_SELECTED_TYPE_PLACEMENT: {
      return {
        ...state,
        selectedSection: initialState.selectedSection,
        selectedFloor: initialState.selectedFloor,
        selectedFloorNumber: initialState.selectedFloorNumber,
        selectedApartmentId: initialState.selectedApartmentId,
      };
    }

    default:
      return state;
  }
};
